import calendar from '../../assets/calendar.svg'
import { forwardRef } from "react"
import Calendar from '../../assets/icons/Calendar'

export const CustomDateInput = forwardRef(({ value, onClick, className, hasTime = true }: any, ref: any) => {
    const [d, m, y] = value.split('/')
    const renderValue = !Boolean(value) ? hasTime ? '__.__.____ __:__' : '__.__.____' : `${d}.${m}.${y}`
    return (
        <div
            className={`${className} flex flex-row bg-valley-background-blue rounded-lg px-3 py-[10.5px] pr-10 relative text-[#1A1A1A]`}
            onClick={onClick}
            ref={ref}
        >
            {renderValue}
            <Calendar
                additionalStyle="absolute top-[10px] right-3"
            />
        </div>
    )
})